module.exports = __webpack_public_path__ + "pm.24f6e95e01b68f3cae37.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/pm.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/pm.svg
// module chunks = styles